import Fooji from "@fooji/microsites";
import { setPage, setLoading, setFlowStep, type RouteStore } from "../stores/route";
import { configStore } from "../stores/config";
import { notify } from "./bugsnag";
import { setCountryWithoutUserSelection, setCountry } from "../stores/country";
import { set as setMode, isDemo } from "../stores/mode";
import type { SupportedCountryCode } from "../constants/countries";
import { differenceInCalendarDays } from "date-fns";
import en from "../constants/copy.en";
import { saveAuthData } from "./auth";
import { campaignCountries, isPrimaryCampaign } from "../constants/countries";

export const isProductionSite = document.location.hostname.endsWith("littlecaesars.com");

export const handleQueryParams = () => {
  const query = new URLSearchParams(document.location.search);

  if (query.has("demo")) {
    setMode("demo");

    const countryParam = query.get("country") as SupportedCountryCode;

    if (campaignCountries.includes(countryParam)) {
      setCountry(countryParam);
    } else {
      setCountryWithoutUserSelection(isPrimaryCampaign ? "US" : "CL");
    }

    setMode("demo");
  }

  if (query.has("code")) {
    sessionStorage.setItem("code", query.get("code") as string);
  }

  if (query.has("clear")) {
    localStorage.removeItem("underage");
  }
}

export const restoreJwt = () => {
  const localStorageJwt = localStorage.getItem("jwt");

  if (localStorageJwt) {
    sessionStorage.setItem("jwt", localStorageJwt);
  }
}

const getConfigAndCheckStatus = async () => {
  try {
    const config = await Fooji.Config.get();
    const status = await Fooji.Campaign.getStatus(config);

    // FIXME: get correct start date
    if (status === "over") {
      return setPage("campaign-over");
    } else if (status === 'teasing') {
      return setPage("campaign-teaser");
    }

    // We'll need this
    configStore.set(config);

    return config;
  } catch (error) {
    notify({
      error,
      errorMessage: "Error setting up microsite"
    });
    console.error("Setup error:", error);

    // TODO: this is what was specced, but I guess this is only the correct behaviour if the error is
    // UnsuccessfulError + message = "Campaign 'campaign_key' is not active."
    return setPage("campaign-over");
  }
};

const fetchSetupData = async () => {
  const config = await getConfigAndCheckStatus();

  const query = new URLSearchParams(document.location.search);

  const isAuth = query.get("auth");
  const authError = query.get("error") as keyof (ReturnType<typeof en>)["error"];

  if (config && isAuth && authError) {
    console.log("Authentication error", authError);
    setPage("error", authError);
  } else if (config && isAuth) {
    await saveAuthData();
  } else if (config) {
    setFlowStep("home");
  }

  // Just to make sure that the user doesn't reload the page as auth...
  history.replaceState({}, document.title, document.location.href.split("?")[0]);

  setLoading(false);
};

export const setupInitialPage = () => {
  if (document.location.hash === "#faq") {
    setLoading(false);
    return setPage("faq");
  } else if (document.location.hash === "#prizes") {
    setLoading(false);
    return setPage("prizes");
  }

  const query = new URLSearchParams(document.location.search);

  if (isDemo()) {
    const page = query.get("page") as RouteStore["page"];
    const errorSetting = query.get("error") as RouteStore["errorSetting"];
    const step = query.get("step") as RouteStore["step"];

    const underage = localStorage.getItem("underage");

    if (underage && differenceInCalendarDays(new Date(), new Date(underage)) < 3) {
      setPage("error", "underage");
    } else if (step) {
      setFlowStep(step);
    } else if (page === "error" && errorSetting) {
      setPage("error", errorSetting);
    } else if (page) {
      setPage(page);
    } else {
      setFlowStep("home")
    }

    setLoading(false);
  } else {
    const underage = localStorage.getItem("underage");

    if (underage && differenceInCalendarDays(new Date(), new Date(underage)) < 3) {
      setPage("error", "underage");
      setLoading(false);
      return;
    } else {
      underage && localStorage.removeItem("underage");
      fetchSetupData()
    }
  }
}